import { render } from "./PublicationInfoBox.vue?vue&type=template&id=70db01fe"
import script from "./PublicationInfoBox.vue?vue&type=script&lang=ts"
export * from "./PublicationInfoBox.vue?vue&type=script&lang=ts"
script.render = render

export default script